// extracted by mini-css-extract-plugin
export default {"IconButton":"TableOfContents-module__IconButton--RCaNg"};